export const AssessmentTemplateVI = {
    "assessmentTemplate": {
        "breadcrumb": "Mẫu đánh giá",
        "heading": {
            "add": "Tạo mới mẫu đánh giá",
            "update": "Cập nhật mẫu đánh giá",
            "generalInfo": "Thông tin chung",
            "assessmentScale": "Thang điểm đánh giá",
            "detail": "Chi tiết mẫu đánh giá",
            "competencyAssessmentList": "Danh sách các tiêu chí"
        },
        "label": {
            "name": "Tên mẫu đánh giá",
            "amount": "Số tiêu chí",
            "createDate": "Ngày tạo"
        },
        "placeholder": {
            "name": "Nhập Tên tiêu chí"
        },
        "message": {
            "add": "Thêm thành công",
            "update": "Cập nhật thành công",
            "delete": "Xóa thành công"
        }
    }
}